export const WISHLIST_LOADING = "WISHLIST_LOADING";
export const ADD_TO_WISHLIST_SUCCESS = "ADD_TO_WISHLIST_SUCCESS";
export const ADD_TO_WISHLIST_FAIL = "ADD_TO_WISHLIST_FAIL";
export const DELETE_WISHLIST_BY_POSTID_SUCCESS =
  "DELETE_WISHLIST_BY_POSTID_SUCCESS";
export const DELETE_WISHLIST_BY_POSTID_FAIL = "DELETE_WISHLIST_BY_POSTID_FAIL";
export const GET_MY_WISHLIST = "GET_MY_WISHLIST";
export const REMOVE_WISHLIST_DATA = "REMOVE_WISHLIST_DATA";
